import { all, takeLatest, put, call, select } from 'redux-saga/effects';

import {
  apiUpdatePhone,
  apiResendPhoneConfirmationCode,
  apiCheckPhoneVerificationCode,
} from '../services/apis';

import { updateUserProfileInfo, afterUpdateUserProfile } from './profile';

import * as actions from '../redux/updatePhone';
import { showAlertBanner } from '../redux/alertBanner';
import {
  getIsProfileCompleted,
  getProfileCompletionMessage,
} from '../redux/profile';

import { ERROR } from '../constants/http';
import {
  ALERT_ERROR_THEME,
  ALERT_SUCCESS_THEME,
} from '../constants/alertBannerThemes';

export function* updatePhone(action) {
  const { userId, phone: userPhone } = action.payload;
  try {
    const response = yield call(apiUpdatePhone, {
      userId,
      phone: userPhone,
    });

    yield put(actions.updatePhoneStageOneSuccess());

    yield call(updateUserProfileInfo, response);
  } catch (err) {
    yield put(actions.updatePhoneStageOneError(err.message));
  }
}

export function* resendConfirmationCode(action) {
  const { userId } = action.payload;
  try {
    const response = yield call(apiResendPhoneConfirmationCode, {
      userId,
    });

    if (response.status === ERROR) {
      throw new Error(response.error_code);
    }

    yield put(actions.resendConfirmationCodeSuccess());
    yield put(
      showAlertBanner({
        message: 'account.codeResentSuccess',
        theme: ALERT_SUCCESS_THEME,
      })
    );
  } catch (err) {
    yield put(actions.resendConfirmationCodeError(err.message));
    yield put(
      showAlertBanner({
        message: err.message,
        theme: ALERT_ERROR_THEME,
      })
    );
  }
}

export function* confirmVerificationCode(action) {
  const { userId, code } = action.payload;
  try {
    const response = yield call(apiCheckPhoneVerificationCode, {
      userId,
      code,
    });

    yield put(actions.confirmVerificationCodeSuccess());
    yield put(actions.updatePhoneComplete());
    const isProfileCompleted = yield select(getIsProfileCompleted);
    const profileCompletionMessage = yield select(getProfileCompletionMessage);

    yield call(updateUserProfileInfo, response);
    yield afterUpdateUserProfile(
      isProfileCompleted,
      'account.nexmoVerifiedSuccess',
      profileCompletionMessage
    );
  } catch (err) {
    yield put(actions.confirmVerificationCodeError(err.message));
  }
}

export default function*() {
  yield all([
    takeLatest(actions.UPDATE_PHONE, updatePhone),
    takeLatest(actions.RESEND_CONFIRMATION_CODE, resendConfirmationCode),
    takeLatest(actions.CONFIRM_VERIFICATION_CODE, confirmVerificationCode),
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/updatePhone.js